export default __webpack_public_path__ + "static/media/store-layouts.ca1a55aa.png";